<template>
    <div class="vx-row sm:w-1/4 w-1/2 mr-5">
        <label class="sm:w-1/3 pt-2 pr-2 text-right">Company:</label>
        <v-select class="sm:w-2/3 bg-white" :clearable="false" :options="companyOptions" v-model="selectedCompany" />
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: "companySelector",
    components: {
        'v-select': vSelect
    },
    computed: {
        selectedCompany: {
            get() {
                return this.$store.state.app.allCompanies[this.$store.state.app.company]
            },
            set({ value }) {
                this.showAlert(value)
            }
        },
        companyOptions() {
            return this.$store.getters['app/getAllCompanies']
        }
    },
    methods: {
        showAlert (value) {
            this.$vs.dialog({
                color: 'warning',
                title: `Warning`,
                text: 'You could loss unsaved data after refresh. Continue anyway?',
                accept: () => {this.acceptAlert(value)}
            })
        },
        acceptAlert(value){
            this.$store.dispatch('app/changeCompany', value)
            window.location.reload()
        }
    },
    mounted() {
        this.$store.dispatch('app/getCompanyFromStorage')
    }
}
</script>
